import React from "react";
import styles from "../Pricing.module.scss";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import master from "../../../../../../../images/v2/master24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import amex from "../../../../../../../images/v2/amex24x24.svg";

function ICPlus({ activeApp, minimized }) {
  const getPricingDataById = (id) => {
    let pricing = activeApp?.prices?.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  const hasValidPricing = (pricingId) => {
    const pricing = getPricingDataById(pricingId);
    return pricing.dollars > 0 || pricing.percent > 0;
  };

  const renderDataItem = (label, value) => (
    <div className={styles.fee_item}>
      <div className={styles.fee_content}>
        <div className={styles.fee_label}>{label}</div>
        <div className={styles.fee_value}>{value}</div>
      </div>
    </div>
  );

  return (
    <div className={styles.ic_plus}>
      <div className={minimized ? styles.ic_plus_row_minimized : styles.ic_plus_row}>
        {hasValidPricing(2) && (
          <div className={styles.ic_plus_section}>
            <div className={styles.ic_plus_header}>
              <h4 className={styles.ic_plus_title}>Rate fees</h4>
              <div className={styles.card_images}>
                <img src={visa} alt="visa" />
                <img src={master} alt="mastercard" />
                <img src={discover} alt="discover" />
              </div>
            </div>
            <div className={styles.fees_grid}>
              {renderDataItem("IC+ Rate", `${getPricingDataById(2).percent}%`)}
              {renderDataItem("Txn Rate", `$ ${getPricingDataById(2).dollars}`)}
            </div>
          </div>
        )}

        {hasValidPricing(35) && (
          <div className={styles.ic_plus_section}>
            <div className={styles.ic_plus_header}>
              <h4 className={styles.ic_plus_title}> AMEX Rates</h4>
              <div className={styles.card_images}>
                <img src={amex} alt="amex" />
              </div>
            </div>
            <div className={styles.fees_grid}>
              {renderDataItem("IC+ Rate", `${getPricingDataById(35).percent}%`)}
              {renderDataItem("Txn Rate", `$ ${getPricingDataById(35).dollars}`)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ICPlus; 